import React, { useRef } from 'react'
import './Hero.scss'
import Deco1 from '../Assets/Images/deco1.webp'
import Deco2 from '../Assets/Images/deco2.webp'
import Deco3 from '../Assets/Images/deco3.webp'
import Deco4 from '../Assets/Images/deco4.webp'
import Deco5 from '../Assets/Images/deco5.webp'
import Deco6 from '../Assets/Images/deco6.webp'
import { Link } from 'react-router-dom'
import { useLanguage } from '../Contexts/LanguageContext'


const decoImages = [Deco1, Deco2, Deco3, Deco4, Deco5, Deco6];

const Hero = () => {
    const decoRefs = useRef([]);
    const { language } = useLanguage();

    const handleMouseMove = (e) => {
        decoRefs.current.forEach((ref) => {
            if (ref) {
                const rect = ref.getBoundingClientRect();
                const dx = e.clientX - (rect.left + rect.width / 2);
                const dy = e.clientY - (rect.top + rect.height / 2);
                const dist = Math.sqrt(dx * dx + dy * dy);
                const moveX = dist < 200 ? -dx / 10 : 0;
                const moveY = dist < 200 ? -dy / 10 : 0;
                ref.style.transform = `translate(${moveX}px, ${moveY}px)`;
            }
        });
    };

    const handleMouseLeave = () => {
        decoRefs.current.forEach((ref) => {
            if (ref) ref.style.transform = '';
        });
    };

    return (
        <div className='hero'>
            <div className='left-side'>
                {language === 'polish' ? (<>
                    <h1>Zdobądź reklamę w miejscu,
                        które użytkownicy naprawdę widzą – w Telegramie.</h1>
                    <h2><span className='blue-text'>Ekosystem Telegrama</span> – od kanałów po Mini Appsy – pozwala precyzyjnie kierować reklamy, generując jakościowy ruch i lepsze konwersje przy niższych kosztach</h2>
                    <div className='hero-checkboxes'>
                        <div className='checkbox-item'>
                            ✅  monetyzacja kanału lub aplikacji
                        </div>
                        <div className='checkbox-item'>
                            ✅  wysokiej jakości konwersje z<br /> reklam
                        </div>
                    </div>
                    <Link to='./login' >
                        <div className='login-btn clinknest-btn'>
                            <span>Załóż konto</span>
                        </div>
                    </Link>
                </>) : (
                    <>
                        <h1>Get advertising in the place
                            users actually see – on Telegram.</h1>
                        <h2><span className='blue-text'>The Telegram ecosystem</span> – from channels to Mini Apps – allows for precise ad targeting, generating quality traffic and better conversions at lower costs</h2>
                        <div className='hero-checkboxes'>
                            <div className='checkbox-item'>
                                ✅  channel or app monetization
                            </div>
                            <div className='checkbox-item'>
                                ✅  high-quality conversions from<br /> ads
                            </div>
                        </div>
                        <Link to='./login' >
                            <div className='login-btn clinknest-btn'>
                                <span>Create account</span>
                            </div>
                        </Link>

                    </>
                )}
            </div>
            <div
                className='desktop-only right-side'
                onMouseMove={handleMouseMove}
                onMouseLeave={handleMouseLeave}
            >
                {decoImages.map((src, i) => (
                    <img
                        key={i}
                        className={`deco deco${i + 1}`}
                        src={src}
                        alt="decoration"
                        ref={el => decoRefs.current[i] = el}
                    />
                ))}
            </div>
            <div className='mobile-only right-side-mobile'>
            </div>
        </div>
    )
}

export default Hero